import { request } from '@umijs/max';

/**
 * 获取登录验证码
 * @description 调用后端接口获取登录所需的验证码信息（如验证码图片/验证码标识等）
 * @returns Promise<API.BaseResponse<API.LoginResponseData>> 包含验证码信息的响应体
 */
export async function fetchLoginCaptcha() {
    return request<API.BaseResponse<API.CaptchaResponseData>>('/v1/biz/captcha', {
        method: 'GET',
    });
}

/**
 * 登录核心请求方法（纯请求层）
 * @description 仅负责发起登录接口请求，不处理任何状态管理、页面跳转、错误提示等业务逻辑
 * @param params 登录请求参数（包含账号、密码、验证码等）
 * @param params - API.LoginParams 登录入参类型，需符合后端接口定义
 * @returns Promise<API.BaseResponse<API.LoginResponseData>> 登录接口响应数据
 */
export async function login(params: API.LoginParams) {
    return request<API.BaseResponse<API.LoginResponseData>>('/v1/biz/login', {
        method: 'POST',
        data: params,
        headers: {}, // 登录态未建立，无需携带认证Token
    });
}

